module.exports = __webpack_public_path__ + "img/head-bg.896bf62.webp";